export const welcome = /* GraphQL */ `
query Welcome {
  welcome
}
`;

export const category2Trades = /* GraphQL */ `
query Category2Trades($filter: Category2TradesFilter!, $limit: Int) {
  category2Trades(filter: $filter, limit: $limit) {
    data {
      dateTime
      quantityTraded
      unitOfMeasure
      tradeStatus
      tradeType
      etwrType
      reasonForTrade
      pricePerUnitTraded
      reliabilityOrLicenceClassType
      destinationWaterMarketsTradingZone
      originWaterMarketsTradingZone
    }
  }
}
`;

export const waterMarketsDecisions = /* GraphQL */ `
query WaterMarketsDecisions($filter: WaterMarketsDecisionFilter!) {
  waterMarketsDecisions(filter: $filter) {
    data {
      decisionTitle
      announcementDateTime
      decisionType
      jsonData
    }
  }
}
`;

export const waterMarketsDecisionsDownload = /* GraphQL */ `
query WaterMarketsDecisionsDownload($dataCategory: String!, $downloadFormat: DownloadFormat, $timestamp: String) {
  waterMarketsDecisionsDownload(dataCategory: $dataCategory, downloadFormat: $downloadFormat, timestamp: $timestamp) {
    zipFile
  }
}
`;

export const controlledLists = /* GraphQL */ `
query ControlledLists {
  controlledLists
}
`;

export const tradingZones = /* GraphQL */ `
query TradingZones {
  tradingZones
}
`;
